import SetupATypes from '../modules/setup/actionTypes';
import DeviceATypes from '../modules/devices/actiontypes';
import OrderATypes from '../modules/orders/actiontypes';
import DTypesATypes from '../modules/devicetypes/actiontypes';
import CustomerATypes from '../modules/customers/actiontypes';
import LocalizationATypes from '../core/localization/actiontypes';
import FeedbackATypes from './feedbackActionTypes';
import DialogATypes from '../modules/dialogs/actionTypes';
import Logger from '../libs/logger';
import { LogArea } from '../libs/logger/const';

const injectedActionTypes = [
  FeedbackATypes,
  LocalizationATypes,
  DialogATypes,
];

export const AT = Object.freeze({
  ...SetupATypes,
  DEVICES: DeviceATypes,
  ORDERS: OrderATypes,
  DTYPES: DTypesATypes,
  CUSTOMERS: CustomerATypes,
  ...FeedbackATypes,
  ...LocalizationATypes,
  ...DialogATypes,
});

export const verifyActionTypes = (allATypes: any, injectedATypes: any[]) => {
  injectedATypes.forEach((atGroup) => {
    Object.keys(atGroup).forEach((atKey) => {
      if (allATypes[atKey] !== atGroup[atKey])
        Logger.error(
          `The key "${atKey}" does not have the correct value. current: ${allATypes[atKey]}; expected: ${atGroup[atKey]}`,
          LogArea.Redux
        );
    });
  });
};

verifyActionTypes(AT, injectedActionTypes);
